import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PermissionSettings = lazy(() =>
  import("@scenes/PermissionSettings/PermissionSettings").then((module) => ({
    default: module.PermissionSettings,
  }))
);

export const permissionSettingsNRO: NavigationRoutingObject = {
  Component: PermissionSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("permission-settings", "Permission Settings"),
  pageNameForTracking: () => "Permission Settings",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "manageCompanySettings",
    });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("permission-settings-alt-keyword-1", "Permission sets")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
